import { Chef } from '@/types/chef';

/**
 * Single source of truth for chef persona metadata used across the app
 * (studio steps, review page, recipe cards). Do NOT create local copies —
 * import from here. Styling accents live in config/chefVisualThemes.ts.
 */
export const chefPersonas: Chef[] = [
  {
    id: "TestKitchenScientist",
    name: "The Test Kitchen Scientist",
    description:
      "Reliable, practical, and foolproof. Balances authenticity with home-cook success.",
    avatar: "/pers1.jpg",
    video: "/videos/chefs/pers1_sm.mp4",
    color: "from-emerald-400 to-teal-500",
  },
  {
    id: "TheVitalityChef",
    name: "The Vitality Chef",
    description:
      "Adapts recipes to enhance health and cater to dietary needs without compromising flavour or satisfaction.",
    avatar: "/pers2.jpg",
    video: "/videos/chefs/pers2_sm.mp4",
    color: "from-orange-400 to-amber-500",
  },
  {
    id: "TheElementalChef",
    name: "The Elemental Chef",
    description:
      "Celebrates ingredient quality and seasonality, teaching foundational techniques to let them shine.",
    avatar: "/pers3.jpg",
    video: "/videos/chefs/pers3_sm.mp4",
    color: "from-amber-400 to-orange-500",
  },
  {
    id: "TheCulinaryAlchemist",
    name: "The Culinary Alchemist",
    description:
      "Transforms simple ingredients into extraordinary dishes through clever techniques and creative magic.",
    avatar: "/pers4.jpg",
    video: "/videos/chefs/pers4_sm.mp4",
    color: "from-orange-400 to-red-500",
  },
  {
    id: "TheHeritageChef",
    name: "The Heritage Chef",
    description:
      "A master of Southeast Asian cuisine who honours tradition and authentic ingredients, guiding cooks to recreate the region's true flavours with precision.",
    avatar: "/pers5.jpg",
    video: "/videos/chefs/pers5_sm.mp4",
    color: "from-lime-400 to-green-500",
  },
  {
    id: "TheEssentialistChef",
    name: "The Essentialist Chef",
    description:
      "Radical simplicity and ingredient purity. Less is more.",
    avatar: "/pers6.jpg",
    video: "/videos/chefs/pers6_sm.mp4",
    color: "from-lime-400 to-green-500",
  },
];
